import { Fragment, useEffect, useState } from 'react';
import { formatShortDateAndHour } from '../../../../../../../../utils/formatDatesAndHours';
import StockOrderShipmentTrackingData from './StockOrderShipmentTrackingData';
import './TrackingAndDatesSection.scss';

interface IDateProperties {
  nameDate: string;
  valueDate?: string | null;
  key?: string;
}

interface IStatusLog {
  id: number;
  status: string;
  createdAt: string;
}

interface ITracking {
  trackingLink: string;
  trackingCode: string;
  estimatedDeliveryDate: string;
}

const TrackingAndDatesSection = ({
  statusLog,
  tracking,
  countryTimeZone,
  setShowProcessModal,
  setIsEditedProcessModal
}: {
  statusLog: IStatusLog[];
  tracking: ITracking;
  countryTimeZone?: number;
  setShowProcessModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsEditedProcessModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [datesList, setDatesList] = useState<IDateProperties[]>([]);

  const shipmentHasTrackingInfo = tracking?.trackingLink || tracking?.estimatedDeliveryDate;

  const getDateByStatus = (status: string): string | undefined => {
    const logEntry = statusLog.find(log => log.status === status);
    return logEntry?.createdAt;
  };

  const unifyDates = () => {
    const trakingDates: IDateProperties[] = [
      { nameDate: 'Cancelado', valueDate: getDateByStatus('Cancelado') },
      { nameDate: 'Entregado', valueDate: getDateByStatus('Entregado') },
      {
        nameDate: 'Proceso de entrega',
        valueDate: shipmentHasTrackingInfo && getDateByStatus('Proceso de entrega') 
          ? getDateByStatus('Proceso de entrega') 
          : undefined,
        key: 'deliveryProcess'
      },
      { nameDate: 'Confirmado', valueDate: getDateByStatus('Confirmado') }
    ];

    const filterTrakingDates: IDateProperties[] = trakingDates.filter(trakingDate => !!trakingDate?.valueDate);
    const orderList = filterTrakingDates.sort(
      (a: IDateProperties, b: IDateProperties) =>
        new Date(b?.valueDate || '').getTime() - new Date(a?.valueDate || '').getTime()
    );
    setDatesList([...orderList]);
  };

  useEffect(() => {
    unifyDates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusLog, tracking]);

  return (
    <div className="trackingAndDatesSection">
      {datesList &&
        datesList.length > 0 &&
        datesList.map((dateInfo, index) => {
          return (
            <Fragment key={`order-items-${dateInfo?.nameDate}-${index}`}>
              <div
                className={`${
                  dateInfo.key === 'deliveryProcess' && !!dateInfo.valueDate ? 'deliveryProcessBlock' : ''
                }`}
              >
                {dateInfo?.valueDate && (
                  <div className={`logisticsDate ${index === 0 ? 'active' : ''}`}>
                    {dateInfo.nameDate} : {formatShortDateAndHour(dateInfo?.valueDate || '')?.textWithTimezone}
                  </div>
                )}
                {dateInfo?.key === 'deliveryProcess' && (
                  <StockOrderShipmentTrackingData
                    tracking={tracking}
                    countryTimeZone={countryTimeZone}
                    setShowProcessModal={setShowProcessModal}
                    setIsEditedProcessModal={setIsEditedProcessModal}
                  />
                )}
              </div>
            </Fragment>
          );
        })}
    </div>
  );
};

export default TrackingAndDatesSection;
